export default __webpack_public_path__ + "static/media/polygon_svg.6802c9a8.svg";